<!-- src/components/stock/StockDeliveryNotesTable.vue -->
<template>
  <div class="card stock-list-card">
    <div class="card-content">
      <!-- ===================================================
           HEADER
           =================================================== -->
      <div class="core-table-header">
        <div class="core-table-header-main">
          <span class="card-title"> Delivery Notes </span>

          <p class="core-table-subtitle">
            {{ notes.length }}
            delivery note{{ notes.length === 1 ? "" : "s" }}
          </p>
        </div>

        <div class="core-table-actions">
          <button
            class="btn-flat waves-effect"
            type="button"
            :disabled="loading"
            @click="$emit('refresh')"
          >
            <i class="material-icons left"> refresh </i>

            Refresh
          </button>
        </div>
      </div>

      <!-- ===================================================
           LOADING
           =================================================== -->
      <div v-if="loading" class="progress">
        <div class="indeterminate"></div>
      </div>

      <!-- ===================================================
           EMPTY
           =================================================== -->
      <div v-else-if="!notes.length" class="core-empty-state">
        No delivery notes have been entered for this venue.
      </div>

      <!-- ===================================================
           TABLE
           =================================================== -->
      <div v-else class="table-wrap">
        <table class="striped highlight core-table stock-table">
          <thead>
            <tr>
              <th>Delivery Date</th>

              <th>Delivery Note No.</th>

              <th class="right-align">Lines</th>

              <th class="right-align">Stock Units</th>

              <th class="right-align">Value</th>

              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="note in notes" :key="note.id">
              <td>
                {{ formatDate(note.delivery_date) }}
              </td>

              <td class="core-reference-cell">
                {{ note.delivery_note_number || "—" }}
              </td>

              <td class="right-align">
                {{ note.line_count || 0 }}
              </td>

              <td class="right-align">
                {{ formatNumber(note.total_quantity) }}
              </td>

              <td class="right-align core-money-cell">
                {{ money(note.total_value) }}
              </td>

              <td>
                <span
                  v-if="note.included_in_count_id"
                  class="core-badge core-badge--success"
                >
                  Included in Count
                </span>

                <span v-else class="core-badge core-badge--warning"> Pending Count </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StockDeliveryNotesTable",

  emits: ["refresh"],

  props: {
    notes: {
      type: Array,
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    number(value) {
      const n = Number(value);

      return Number.isFinite(n) ? n : 0;
    },

    formatDate(value) {
      const clean = String(value ?? "")
        .trim()
        .slice(0, 10);

      if (!/^\d{4}-\d{2}-\d{2}$/.test(clean)) {
        return clean || "—";
      }

      const [year, month, day] = clean.split("-");

      return `${day}/${month}/${year}`;
    },

    formatNumber(value) {
      return this.number(value).toLocaleString("en-GB", {
        maximumFractionDigits: 2,
      });
    },

    money(value) {
      return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
      }).format(this.number(value));
    },
  },
};
</script>

<style scoped>
.stock-list-card {
  width: 100%;
  margin: 0 0 18px 0;
  overflow: hidden;
}
</style>
